import script from "./donateCampaign.vue?vue&type=script&setup=true&lang=js"
export * from "./donateCampaign.vue?vue&type=script&setup=true&lang=js"

import "./donateCampaign.vue?vue&type=style&index=0&id=1928ba6e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1928ba6e"]])

export default __exports__